var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeaturePlaceholder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "highlight_checklists") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 11.91011,
    width: 48,
    height: 48
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.91013,19.9101v32h-32v-32h32m8-8h-48v48h48v-48Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.08989,
    y: 11.91011,
    width: 48,
    height: 48
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116,84v32H84V84h32m8-8H76v48h48V76Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.91011,
    y: 76,
    width: 48,
    height: 48
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.08989,
    y: 76,
    width: 48,
    height: 48
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116,148.08991v32H84v-32h32m8-8H76v48h48v-48Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.91013,148.08991v32h-32v-32h32m8-8h-48v48h48v-48Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.08988,148.08991v32h-32v-32h32m8-8h-48v48h48v-48Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturePlaceholder);
export default __webpack_public_path__ + "static/media/feature_placeholder.9b4374f8168ce96cf79cd9328bd1b9da.svg";
export { ForwardRef as ReactComponent };